import React from 'react'

import { SearchMode } from 'src/types/search'
import ConnectedSuggester from 'src/comps/SuggesterConnected'

export function Suggester() {
  return <ConnectedSuggester className="suggester-wrapper" mode={SearchMode.Full} />
}
